import Layout from "../../../layout/Layout";
import { AdminContext } from "./context";

export default ({ user }) => {
  return (
    <AdminContext.Provider value={user}>
      <Layout user={user} />
    </AdminContext.Provider>
  );
};
